import React from "react";
import { useParams } from "react-router-dom";
import Edit from "../../../../../Common/Components/EditTimeTable";
import { useContract } from "./Hooks";

const EditTimeTable = () => {
  const { slug } = useParams();
  const {
    toggleSelect,
    arrLength,
    isInArray,
    // checkTimes,
    loading,
    // checkDate,
    clearTimes,
    renderTimes,
    submit,
    submitRange
  } = useContract();
  return (
    <Edit
      item_id={slug}
      editBall={true}
      multi={{
        status: true,
        toggleSelect,
        arrLength,
        isInArray,
        clearTimes,
        renderTimes,
        submit,
        loading,
      }}
      range={{
        status: true,
        toggleSelect,
        arrLength,
        isInArray,
        clearTimes,
        renderTimes,
        submitRange,
        loading,
      }}
    />
  );
};

export default EditTimeTable;
